export default __webpack_public_path__ + "static/media/2365.fab28dc5.png";